import { render, staticRenderFns } from "./AutoImportPanel.vue?vue&type=template&id=44d352ac&scoped=true"
import script from "./AutoImportPanel.vue?vue&type=script&lang=js"
export * from "./AutoImportPanel.vue?vue&type=script&lang=js"
import style0 from "./AutoImportPanel.vue?vue&type=style&index=0&id=44d352ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d352ac",
  null
  
)

export default component.exports